import { classNames } from 'shared/lib/classNames/classNames';
import { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import cls from './Button.module.scss';

export enum ButtonTheme {
    NAVIGATION = 'navigation',
    BACKTO = 'backTo',
    AGE = 'age',
    PLOT = 'nextPlot',
    MAIN = 'main',
    buttonTheme = 'buttonTheme',
    PRIMARY = 'PRIMARY',
    NEXT = 'NEXT',
    BACK = 'BACK',
    AUTH = 'AUTH',
    TEXT = 'TEXT',
    TEXT2 = 'TEXT2',
    TAB = 'TAB',
    CATEGORY = 'CATEGORY',
    TABTEXT = 'TABTEXT',
    SLIDER = 'SLIDER',
    PAY = 'PAY',
    BUY = 'BUY',
    COUNTER = 'COUNTER',
    ONLY_ICON = 'ONLY_ICON',
    BACK_TO_GAME = 'BACK_TO_GAME',
    ROUND = 'ROUND',
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    theme?: ButtonTheme;
    icon?: ReactNode;
    reverse?: boolean;
}
export const Button: FC<ButtonProps> = (props) => {
    const {
        className,
        children,
        reverse,
        theme,
        icon,
        ...otherProps
    } = props;

    return (
        <button
            type="button"
            className={classNames(cls.Button, { [cls.reverse]: reverse }, [className, cls[theme]])}
            {...otherProps}
        >
            {icon && <span className={cls.icon}>{icon}</span>}
            <span className={cls.text}>{children}</span>
        </button>
    );
};
